import { createAsyncThunk } from "@reduxjs/toolkit";

import { ChatStatus, type ChatChannelWithLastMessage } from "@fitness-app/data-models/entities/Chat";

import { getViewerId } from "../../../helpers/getViewerId";
import { getPageRange } from "../../../helpers/getPageRange";
import { type AsyncThunkCreator } from "../../../index";
import { CHAT_REDUCER_NAME } from "../types";
import { buildOrderedChatChannelsListQuery, type ChatChannelsListQueryParams } from "./buildChatChannelsListQuery";

export type GetNextChatListPagePayload = ChatChannelsListQueryParams;

export const getNextChatListPage = createAsyncThunk<
  { data: ChatChannelWithLastMessage[]; page: number; isLastPage: boolean },
  GetNextChatListPagePayload,
  AsyncThunkCreator<string>
>(`${CHAT_REDUCER_NAME}/getNextChatListPage`, async (payload, { rejectWithValue, getState, extra: { db, auth } }) => {
  const viewerId = await getViewerId(auth);

  const { channelsSize, channelsListStatus, archivedListStatus } = getState().chat;

  const { start, stop, currentPage } = getPageRange(
    payload.status === ChatStatus.Archived ? archivedListStatus.currentPage : channelsListStatus.currentPage,
    channelsSize,
    true,
  );

  const query = buildOrderedChatChannelsListQuery(db, viewerId, payload);

  const { error, data } = await query.limit(channelsSize).range(start, stop).returns<ChatChannelWithLastMessage[]>();

  if (error) {
    return rejectWithValue(error.message);
  }

  return { data, page: currentPage + 1, isLastPage: data.length < channelsSize };
});
